import React, { FC } from 'react';
import { SpacerProps } from '~/core/dto/components/spacer';

import './Spacer.styles.css';

const Spacer: FC<SpacerProps> = ( { size, horizontal } ) => <div className="spacerContainer" style={{ width: horizontal ? size : '100%', height: horizontal ? '100%' : size }} />;

export default Spacer;
